<template>
  <div>
    <el-row>
      <el-col :span="18">
        <div style="margin-bottom: 10px;" v-if="taskInfo.goods_list.length>0 && taskInfo.business_website">
          <h3>{{taskInfo.business_name}}</h3>
          <p v-for="website in taskInfo.business_website.split(',')">{{website}}</p>
        </div>
        <span style="display:none">{{taskInfo}}</span>
      </el-col>
      <el-col :span="6" class="text-right" v-if="editable">
        <a @click="edit()">更改</a>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'ProductList',
  props: ['editable'],
  components: {
  },
  data () {
    return {
      websiteList: []
    }
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  created () {
  },
  methods: {
    edit () {
      this.taskInfo.editConfirmProduct = true
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$router.push({ path: 'products' , query: this.$route.query})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  line-height: 25px;
}

p {
  line-height: 18px;
  margin-bottom: 5px;
  color: #666666;
}

a {
  font-size: 16px;
  cursor: pointer;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/product/ProductTitle.vue